import { render, staticRenderFns } from "./Transfer.vue?vue&type=template&id=35ad609e&scoped=true&"
import script from "./Transfer.vue?vue&type=script&lang=js&"
export * from "./Transfer.vue?vue&type=script&lang=js&"
import style0 from "./Transfer.vue?vue&type=style&index=0&id=35ad609e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ad609e",
  null
  
)

export default component.exports